import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from '../components/Template/LoginTemplate/LoginPage';
import GeneralBody from '../components/HOC/GeneralBody/GeneralBody';
import Loader from '../components/Moecules/Loader/Loader';
import DashboardPage from '../components/Template/DashboardTemplate/DashboardPage';
import UserProfile from '../components/Template/UserProfileTemplate/UserProfile';
import UsersPage from '../components/Template/UsersTemplate/UsersPage';
import NewTemplateEmail from '../components/Template/NewTemplateEmail/NewTemplateEmail';
import EmailPage from '../components/Template/EmailTemplate/EmailPage';
import SettingsBody from '../components/HOC/SettingsBody/SettingsBody';
import SingleApplicantPAge from '../components/Template/SingleApplicantTemplate/SingleApplicantPAge';
import AplicantsPage from '../components/Template/ApplicantTemplate/AplicantsPage';
import CampaignPage from '../components/Template/Campaign/Campaigns/CampaignPage';
import EmailTemCampaignPage from '../components/Template/Campaign/EmailCampaign/EmailTemCampaignPage';
import AudiencePage from '../components/Template/Campaign/Audience/AudiencePage';
import AddExternalContact from '../components/Moecules/Settings/ExternalContact/AddExternalContact';
import UsersAssignmentPage from '../components/Template/UserAssignmentPage/UsersAssignmentPage';
import SingleCampaignPage from '../components/Template/Campaign/SingleCampaign/SingleCampaignPage';
import NewAudiencePage from '../components/Template/Campaign/Audience/NewAudiencePage';
import NewCampaignPage from '../components/Template/Campaign/Campaigns/NewCampaignPage';
import SingleAudiencePage from '../components/Template/SingleAudience/SingleAudiencePage';
import ReferencePage from '../components/Template/RecomendationTemplate/ReferencePage';
import SingleExternalContactPage from '../components/Template/ContactPage/SingleExternalContactPage';
import ExternalContactPage from '../components/Template/ExternalContactTemplate/ExternalContactPage';
import UnauthorizedPages from '../components/Template/UnauthorizedPage/UnauthorizedPages';
import { useFetchSidbarPages } from '../Hooks/SideBAr';
import PrivateRoutesJWT from './protected-routing/PrivateRoutesJWT';
import PageNotFound from './protected-routing/page-not-found/PageNotFound';
import RecomemdationPage from '../components/Template/RecomendationTemplate/RecomemdationPage';
import MailPage from '../components/Template/mail-page/MailPage';

const componentMap = {
  dashboard: DashboardPage,
  profile: UserProfile,
  'external-contact': ExternalContactPage,
  users: UsersPage,
  'users-assignment': UsersAssignmentPage,
  applicants: AplicantsPage,
  'single-applicant': SingleApplicantPAge,
  settings: SettingsBody,
  email: EmailPage,
  campaigns: CampaignPage,
  'campaign-audience': AudiencePage,
  'campaign-templateEmail': EmailTemCampaignPage,
  recommendation: ReferencePage,
  unauthorized: UnauthorizedPages,
};

const renderRoutes = (pages = []) => {
  return pages?.map((page) => (
    <React.Fragment key={page.pageId}>
      {page.path && componentMap[page.pageName] && (
        <Route
          path={page.path}
          element={React.createElement(componentMap[page.pageName])}
        />
      )}
      {page.childPages && renderRoutes(page.childPages)}
    </React.Fragment>
  ));
};
const MainRoutes = () => {
  const { data: pages, isLoading, refetch, isError } = useFetchSidbarPages();
  const [localPages, setLocalPages] = useState([]);
  const [token, setToken] = useState(null);

  useEffect(() => {
    setLocalPages(pages);
  }, [pages]);

  useEffect(() => {
    if (isError) {
      console.error('Error fetching sidebar pages. Clearing token.');
      localStorage.removeItem('token');
      setToken(null);
      window.location.href = '/';
    }
  }, [isError]);

  useEffect(() => {
    if (token) refetch();
  }, [token]);

  if (isLoading)
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#1b224c31',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Loader />
        </div>
      </div>
    );

  return (
    <Routes>
      <Route path='/' element={<LoginPage setToken={setToken} />} />
      <Route path='/login' element={<LoginPage setToken={setToken} />} />
      <Route element={<PrivateRoutesJWT />}>
        <Route path='/home' element={<GeneralBody />}>
          {localPages?.data ? renderRoutes(localPages?.data) : null}
          <Route
            path='/home/applicants/:id'
            element={<SingleApplicantPAge />}
          />
          <Route
            path='/home/applicants/:id'
            element={<SingleApplicantPAge />}
          />
          <Route
            path='/home/interested/:id'
            element={<SingleApplicantPAge />}
          />
          <Route path='/home/new-email' element={<NewTemplateEmail />} />
          <Route path='/home/new-email/:id' element={<NewTemplateEmail />} />
          <Route
            path='/home/campaign-details/:id'
            element={<SingleCampaignPage />}
          />
          <Route path='/home/new-audience/:id' element={<NewAudiencePage />} />
          <Route path='/home/new-audience' element={<NewAudiencePage />} />
          <Route
            path='/home/audienceDetails/:id'
            element={<SingleAudiencePage />}
          />
          <Route path='/home/new-campaign/:id' element={<NewCampaignPage />} />
          <Route path='/home/new-campaign' element={<NewCampaignPage />} />
          <Route path='add-externalContact' element={<AddExternalContact />} />
          <Route
            path='/home/contact-details/:id'
            element={<SingleExternalContactPage />}
          />
          <Route
            path='/home/edit-externalContact'
            element={<AddExternalContact />}
          />
          <Route
            path='/home/edit-externalContact/:id'
            element={<AddExternalContact />}
          />
          <Route path='profile' element={<UserProfile />} />
          <Route path='mail' element={<MailPage />} />
        </Route>
      </Route>

      <Route path='/recomendation' element={<ReferencePage />} />
      <Route path='/unauthorized' element={<UnauthorizedPages />} />
      <Route path='*' element={<PageNotFound />} />
    </Routes>
  );
};

export default MainRoutes;
